import { Queue, Loan } from '../types'

export const QUEUES: Queue[] = [
  {
    id: 'q1',
    name: 'Credit Pulled 10+ Day List',
    apiName: 'Credit_Pulled_10_Days',
    count: 12,
    audienceSummary: 'Admin, Exec/Legacy/Sr. Bankers',
    recordCriteria: [
      'Stage = Credit Pulled',
      'Credit_Pulled_10_Days__c = true',
      'Loan_Purpose__c != Purchase',
    ],
    audienceCriteria: {
      groups: ['Admin_Group'],
      roles: ['Executive_Bankers', 'Legacy_Bankers', 'Senior_Bankers'],
      profiles: [],
      permSets: [],
    },
  },
  {
    id: 'q2',
    name: 'App Out 10+ Day List',
    apiName: 'App_Out_10_Days',
    count: 8,
    audienceSummary: 'Admin, Exec/Legacy/Sr. Bankers',
    recordCriteria: [
      'Stage = App Out',
      'App_Out_10_Days__c = true',
      'Loan_Purpose__c != Purchase',
    ],
    audienceCriteria: {
      groups: ['Admin_Group'],
      roles: ['Executive_Bankers', 'Legacy_Bankers', 'Senior_Bankers'],
      profiles: [],
      permSets: [],
    },
  },
  {
    id: 'q3',
    name: 'Package Back 10+ Day List',
    apiName: 'Package_Back_10_Days',
    count: 5,
    audienceSummary: 'Admin, Exec/Legacy/Sr. Bankers',
    recordCriteria: [
      'Stage = Package Back',
      'Package_Back_10_Days__c = true',
      'Loan_Purpose__c != Purchase',
    ],
    audienceCriteria: {
      groups: ['Admin_Group'],
      roles: ['Executive_Bankers', 'Legacy_Bankers', 'Senior_Bankers'],
      profiles: [],
      permSets: [],
    },
  },
  {
    id: 'q4',
    name: 'Second Look List',
    apiName: 'Withdrawn_10_Days',
    count: 15,
    audienceSummary: 'Exec/Legacy Bankers',
    recordCriteria: [
      'Stage = Withdrawn',
      'Claimed__c = false',
      'Loan_Purpose__c != Purchase',
      'Reason_For_Withdrawal__c != Registered Again,Duplicate',
    ],
    audienceCriteria: {
      groups: [],
      roles: ['Executive_Bankers', 'Legacy_Bankers'],
      profiles: [],
      permSets: [],
    },
  },
  {
    id: 'q5',
    name: 'Not Re Registered List',
    apiName: 'X24_Hour_Re_Register_List',
    count: 3,
    audienceSummary: 'Exec/Legacy Bankers',
    recordCriteria: [
      'Stage = Withdrawn',
      'Claimed__c = false',
      'Reason_For_Withdrawal__c = Registered Again',
      'X24_Hour_Not_Re_Registered__c = true',
      'Loan_Purpose__c != Purchase',
    ],
    audienceCriteria: {
      groups: [],
      roles: ['Executive_Bankers', 'Legacy_Bankers'],
      profiles: [],
      permSets: [],
    },
    warnings: [
      { type: 'warning', message: 'Risky broad visibility (>500 users)' },
    ],
  },
  {
    id: 'q6',
    name: 'Credit Alert List',
    apiName: 'Credit_Alert_List_View',
    count: 7,
    audienceSummary: 'Exec/Legacy Bankers',
    recordCriteria: [
      'Credit_Alert_List__c = true',
      'Loan_Officer_Active__c = false',
    ],
    audienceCriteria: {
      groups: [],
      roles: ['Executive_Bankers', 'Legacy_Bankers'],
      profiles: [],
      permSets: [],
    },
    isOpportunityOnly: true,
  },
  {
    id: 'q7',
    name: 'Client Retention List',
    apiName: 'Credit_Retention_List',
    count: 4,
    audienceSummary: 'Admin, Legacy Bankers',
    recordCriteria: [
      'Credit_Retention_List__c = true',
      'Client_Retention_Process_Completed__c = false',
    ],
    audienceCriteria: {
      groups: ['Admin_Group'],
      roles: ['Legacy_Bankers'],
      profiles: [],
      permSets: [],
    },
    isOpportunityOnly: true,
    warnings: [
      {
        type: 'error',
        message: 'Conflicting criteria detected in audience rules',
      },
    ],
  },
  {
    id: 'q8',
    name: 'My Claimed Loans',
    apiName: 'My_Claimed_Loans',
    count: 12,
    audienceSummary: 'Admin, Exec/Legacy/Sr. Bankers',
    recordCriteria: [
      '(Credit_Pulled_10_Day_User__c = $USER OR ...) AND Loan_Purpose__c != Purchase',
    ],
    audienceCriteria: {
      groups: ['Admin_Group'],
      roles: ['Executive_Bankers', 'Legacy_Bankers', 'Senior_Bankers'],
      profiles: [],
      permSets: [],
    },
    isPinned: true,
  },
]

const generateLoans = (): Loan[] => {
  const loans: Loan[] = []
  const states = ['FL', 'TX', 'CA', 'AZ', 'NC', 'NY', 'IL']
  const purposes = ['Refinance', 'Cash-Out', 'Rate-Term']
  const types = ['Conventional', 'FHA', 'VA', 'Jumbo']
  const lenders = ['Rocket', 'UWM', 'PennyMac', 'Freedom', 'LoanDepot']
  const partners = [
    'Sarah Jenkins',
    'Mike Ross',
    'Harvey Specter',
    'Louis Litt',
    'Donna Paulsen',
  ]

  let idCounter = 1000

  QUEUES.forEach((queue) => {
    // Generate fewer loans than the count for brevity, but enough to scroll
    const numToGenerate = Math.min(queue.count, 8)

    for (let i = 0; i < numToGenerate; i++) {
      const urgency = Math.floor(Math.random() * 25) + 5 // 5 to 30 days
      let claimState: Loan['claimState'] = 'Unclaimed'

      if (queue.id === 'q8') {
        claimState =
          Math.random() > 0.5
            ? 'In Progress - Loan Claimed'
            : 'Successful Claim'
      } else if (Math.random() > 0.8) {
        claimState = 'Unsuccessful Claim - Returned to List'
      }

      const relevantDateLabel =
        queue.id === 'q1'
          ? 'Orig. Credit Pull'
          : queue.id === 'q2'
            ? 'App Out Date'
            : queue.id === 'q3'
              ? 'Package Back Date'
              : queue.id === 'q4' || queue.id === 'q5'
                ? 'Withdrawn Date'
                : 'Alert Date'

      const d = new Date()
      d.setDate(d.getDate() - urgency)

      loans.push({
        id: `L-${idCounter++}`,
        name: `OPP-${idCounter}`,
        borrowerName: `Borrower ${idCounter}`,
        stage: queue.recordCriteria[0].split(' = ')[1] || 'Processing',
        relevantDateLabel,
        relevantDate: d.toISOString().split('T')[0],
        partner: partners[Math.floor(Math.random() * partners.length)],
        stl: `STL-${Math.floor(Math.random() * 10)}`,
        sdl: `SDL-${Math.floor(Math.random() * 10)}`,
        lender: lenders[Math.floor(Math.random() * lenders.length)],
        type: types[Math.floor(Math.random() * types.length)],
        purpose: purposes[Math.floor(Math.random() * purposes.length)],
        amount: Math.floor(Math.random() * 1000000) + 180000,
        rate: (Math.random() * 2 + 5.5).toFixed(3) as unknown as number,
        propertyState: states[Math.floor(Math.random() * states.length)],
        lastUpdate: new Date(Date.now() - Math.random() * 100000000)
          .toISOString()
          .split('T')[0],
        claimState,
        urgencyDays: urgency,
        queueId: queue.id,
      })
    }
  })

  return loans
}

export const LOANS = generateLoans()
